import { createNavigation } from "next-intl/navigation"
import { routing } from "./routing"

// Locale-aware navigation helpers. Use these (instead of next/link &
// next/navigation) on marketing pages so links automatically carry the active
// locale prefix — `<Link href="/pricing">` resolves to `/es/pricing` when the
// active locale is Spanish, and `/pricing` for English.
export const { Link, redirect, usePathname, useRouter, getPathname } =
  createNavigation(routing)
